import React, { useState, useRef, useEffect } from "react";
import "../../css/CRUDModal.css";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import { ICONS } from "../../assets/Icons";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Swal from "sweetalert2";
import SuccessModal from "../successModal/successModal";
import useExcelDownloader from "../../Hooks/useExcelDownloader";
import CustomDropdown from "../common/CustomDropdown";
import LeftCircle from "../../assets/Icons/Left Circle B.png";
import RightCircle from "../../assets/Icons/Right Circle A.png";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";

const TemplatePreview = ({ template }) => {
  if (!template || !template.sms_content) {
    return (
      <div style={{ color: "#777", fontStyle: "italic", fontSize: "13px", padding: "12px", backgroundColor: "#FFF", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
        SMS Content not available.
      </div>
    );
  }

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        padding: "16px",
        borderRadius: "10px",
        border: "1px solid #E8EDF5",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
        maxWidth: "100%",
        textAlign: "left",
        fontSize: "13px",
        color: "#454545",
      }}
    >
      <div style={{ fontWeight: "600", color: "#1A1A1A", marginBottom: "8px", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
        SMS Content
      </div>
      <div style={{ backgroundColor: "#F8FAFF", padding: "8px 12px", borderRadius: "6px", border: "1px solid #EEF5FF", color: "#1A1A1A", whiteSpace: "pre-wrap" }}>
        {template.sms_content}
      </div>
    </div>
  );
};
const LocalTemplateDropdown = ({
  options = [],
  valueKey,
  labelKey,
  value,
  onChange,
  onOpen,
  placeholder = "Select",
  onHoverItem,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selected = options.find((item) => item[valueKey] === value);

  const handleToggle = () => {
    if (!open && onOpen) {
      onOpen();
    }
    setOpen(!open);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        type="button"
        onClick={handleToggle}
        className="w-full border rounded-md p-2 flex justify-between items-center bg-white"
        style={{ borderColor: "#E8EDF5", height: "42px", fontSize: "14px" }}
      >
        <span style={{ color: selected ? "#1A1A1A" : "#9CA3AF" }}>
          {selected ? selected[labelKey] : placeholder}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          style={{ width: "16px", height: "16px", color: "#6D6D6D" }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {open && (
        <ul
          className="absolute z-50 mt-1 w-full max-h-48 overflow-y-auto bg-white border rounded-md shadow-lg"
          style={{
            borderColor: "#E8EDF5",
            listStyle: "none",
            padding: 0,
            margin: 0,
          }}
        >
          {options.length === 0 ? (
            <li
              className="p-2 text-center text-gray-400"
              style={{ fontSize: "14px" }}
            >
              No data found
            </li>
          ) : (
            options.map((item, index) => (
              <li
                key={index}
                className="p-2 hover:bg-gray-100 cursor-pointer text-left"
                style={{ fontSize: "14px", color: "#1A1A1A" }}
                onClick={() => {
                  onChange(item);
                  setOpen(false);
                  onHoverItem(null);
                }}
                onMouseEnter={() => onHoverItem(item)}
                onMouseLeave={() => onHoverItem(null)}
              >
                {item[labelKey]}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

const BulkMessageModal = ({ show, handleClose, callApi }) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const { downloadExcel } = useExcelDownloader();
  const fileInputRef = useRef(null);
  const profileRef = useRef(null);

  const [profileOpen, setProfileOpen] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [senderIdValue, setSenderIdValue] = useState("");
  const [entityIdValue, setEntityIdValue] = useState("");
  const [templateIdValue, setTemplateIdValue] = useState("");
  const [isValidated, setIsValidated] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [templatesData, setTemplatesData] = useState([]);

  const selectedTemplate = templatesData?.find(
    t => String(t.template_id) === String(templateIdValue)
  );

  const toggleProfileDropdown = () => setProfileOpen(!profileOpen);

  const [formData, setFormData] = useState({
    username: loggedInUserName,
    senderId: [],
    entityId: [],
    templateId: [],
    // smsText: "",
  });
  const [errors, setErrors] = useState({
    senderId: "",
    entityId: "",
    templateId: "",
    // smsText: "",
    csv: "",
  });

  const handleSenderIdChange = (event) => {
    const selectedProfile = event.target.value;
    const { id, value } = event.target;

    toggleProfileDropdown();
    setSenderIdValue(selectedProfile);
    setIsValidated(false);
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
      // senderId: value,
    }));
    setErrors({});
  };

  const handleEntityIdChange = (event) => {
    // const { id, value } = event.target;
    const selectedProfile = event.target.value;

    toggleProfileDropdown();
    setEntityIdValue(selectedProfile);
    setIsValidated(false);
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [id]: value,
    // }));
  };

  const handleTemplateIdChange = (event) => {
    const { id, value } = event.target;
    const selectedProfile = event.target.value;

    toggleProfileDropdown();
    setTemplateIdValue(selectedProfile);
    setIsValidated(false);
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [id]: value,
    // }));
  };

  const handlefetchSenderId = () => {
    fetchSenderIdList();
  };

  const fetchLoginCustomerData = async () => {
    const payload = {
      username: loggedInUserName,
      userId: loggedInUserName,
    };
    try {
      setLoading(true);
      const response = await axiosPostApi(apiList.FETCH_USER_DATA, payload);
      if (response?.status === 200 && response?.data?.respCode === "00") {
        const data = response?.data?.data[0] || [];

        setLoading(false);
        setFormData((prevData) => ({
          ...prevData,
          customerCode: data?.userCode,
        }));
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchSenderIdList = async () => {
    const payload = {
      username: loggedInUserName,
      customerCode: formData?.customerCode,
    };
    try {
      setIsLoading(true);
      const response = await axiosPostApi(apiList.BULK_SENDER_ID, payload);
      if (response?.status === 200 && response?.data?.respCode === "00") {
        const data = response?.data?.data || [];

        setIsLoading(false);
        const senderId = data?.senderIds.map((senderIdL) => ({
          senderIdL: senderIdL,
        }));
        setFormData((prevData) => ({
          ...prevData,
          senderId: senderId,
        }));
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchEntityTemplateIdList = async () => {
    const payload = {
      username: loggedInUserName,
      customerCode: formData?.customerCode,
      sendorId: senderIdValue,
    };
    try {
      setLoading(true);
      const response = await axiosPostApi(
        apiList.FETCH_ENTITY_TEMPLATE_ID,
        payload,
      );
      if (response?.status === 200 && response?.data?.respCode === "00") {
        const data = response?.data?.data || [];

        setLoading(false);
        const templateId = data?.templateIds.map((templateId) => ({
          templateId: templateId,
        }));
        const entityId = data?.entityIds.map((entityId) => ({
          entityId: entityId,
        }));

        const templates = data?.templates || [];
        setTemplatesData(templates);

        setFormData((prevData) => ({
          ...prevData,
          templateId: templateId,
          entityId: entityId,
        }));
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  // const entityList = () => {
  //   if (!senderIdValue) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       senderId: "Please select a Sender ID",
  //     }));
  //     return;
  //   }
  //   fetchEntityTemplateIdList();
  // };

  const entityList = () => {
    if (!senderIdValue) {
      setErrors((prev) => ({
        ...prev,
        senderId: "Please select a Sender ID",
      }));
      return;
    }

    // Already loaded, don't call API again
    if (
      formData.entityId.length > 0 &&
      formData.templateId.length > 0
    ) {
      return;
    }

    fetchEntityTemplateIdList(senderIdValue);
  };

  useEffect(() => {
    if (show) {
      fetchLoginCustomerData();
    }
  }, [show]);

  // const validate = () => {
  //   const newErrors = {};

  //   formData.smsText = formData.smsText?.trim();
  //   if (!formData.smsText) {
  //     newErrors.smsText = "Name is required";
  //   } else if (formData.smsText.length < 2 || formData.smsText.length > 50) {
  //     newErrors.smsText = "Name must be between 2 and 50 characters long";
  //   }

  //   return newErrors;
  // };

  const handleAddUser = (e) => {
    e.preventDefault();
    // const validationErrors = validate();
    // setErrors(validationErrors);

    handleCsvBulkUpload();
    // if (Object.keys(validationErrors).length === 0) {
    //   handleCsvBulkUpload();
    // }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let updatedValue = value;
    if (id === "name") {
      updatedValue = value.toUpperCase();
    } else if (id === "emailId") {
      updatedValue = value.toLowerCase();
    } else if (id === "mobileNo") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }
    setFormData({ ...formData, [id]: updatedValue });
  };

  const handleBack = () => {
    handleClose();
    haldleSetEmptyField();
  };

  const haldleSetEmptyField = () => {
    setFormData({
      username: "",
      senderId: [],
      entityId: [],
      templateId: [],
      // smsText: "",
    });
    setSenderIdValue("");
    setEntityIdValue("");
    setTemplateIdValue("");
    setCsvFile(null);
    setIsValidated(false);
    setErrors({});
    setHoveredItem(null);
    setTemplatesData([]);
  };

  const headers = [
    { key: "SrNo", label: "Sr No" },
    { key: "MobileNo", label: "Mobile No" },
    { key: "Template", label: "Template" },
  ];

  const data = [{ SrNo: "", MobileNo: "", Template: "" }];

  const handelDownloadExcelFormat = () => {
    downloadExcel(data, headers, "BulkMessageFormat.xlsx");
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    setCsvFile(e.target.files[0]);
    setIsValidated(false);
    setErrors({});
  };

  const bulkUpload = async (payload) => {
    setLoading(true);
    try {
      // Make the API call
      const response = await axiosPostApi(apiList.BULK_UPLOAD, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.status === 200 && response?.data?.respCode === "00") {
        setShowSuccessModal(true);
        haldleSetEmptyField();
        callApi();
        // handleClose();
      } else if (response?.data?.respCode === "05") {
        setLoading(false);
        CustomAlert({
          title: "Info",
          text:
            response?.data?.message || "Invalid credentials. Please try again!",
          icon: "info",
          confirmButtonText: "Retry",
        });
      } else {
        CustomAlert({
          title: "Data Fetch Error",
          text:
            response?.data?.message ||
            "No data available for the specified criteria.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: `There was an error: ${error?.message}`,
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const validateBulkUpload = async () => {
    if (!csvFile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        csv: "Please select a CSV file before validation.",
      }));
      return;
    }

    const formDataA = new FormData();

    formDataA.append("senderId", senderIdValue);
    formDataA.append("entityId", entityIdValue);
    formDataA.append("templateId", templateIdValue);
    formDataA.append("channel", "WEB");
    formDataA.append("username", loggedInUserName);
    formDataA.append("file", csvFile);

    try {
      setLoading(true);

      const response = await axiosPostApi(
        apiList.BULK_UPLOAD_VALIDATE,
        formDataA,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response?.status === 200 && response?.data?.respCode === "00") {
        setIsValidated(true);

        CustomAlert({
          title: "Success",
          text: response?.data?.message || "Validation Successful",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        setIsValidated(false);
        const errorFileUrl = response?.data?.data?.errorFileUrl;

        CustomAlert({
          title: "Validation Failed",
          text: response?.data?.message || "Validation failed.",
          icon: "error",
          confirmButtonText: errorFileUrl ? "Download Error File" : "OK",
        }).then((result) => {
          if (result.isConfirmed && errorFileUrl) {
            const fullUrl = `https://sms-app.appantech.com${errorFileUrl}`;
            window.open(fullUrl, "_blank");
          }
        });
      }
    } catch (error) {
      setIsValidated(false);

      Swal.fire({
        title: "Error",
        text: error?.message,
        icon: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCsvBulkUpload = () => {
    if (!csvFile) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        csv: "Please select a CSV file before uploading.",
      }));
      return;
    }
    const formDataA = new FormData();
    formDataA.append("senderId", senderIdValue);
    formDataA.append("entityId", entityIdValue);
    formDataA.append("templateId", templateIdValue);
    // formDataA.append("smsText", formData?.smsText);
    formDataA.append("channel", "WEB");
    formDataA.append("username", loggedInUserName);
    formDataA.append("file", csvFile);

    try {
      bulkUpload(formDataA);
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    handleClose(false);
  };

  const isDisabled = !senderIdValue || !entityIdValue || !templateIdValue;

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1031,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "597px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              {/* <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              /> */}
              <div
                className="modal-header flex justify-between"
                style={{
                  background: "linear-gradient(90deg,#F8FAFF,#EEF5FF)",
                  borderRadius: "18px 18px 0 0",
                  padding: "18px 24px",
                  borderBottom: "1px solid #E8EDF5",
                }}
              >
                <div className="flex items-center gap-2">
                  <SmsOutlinedIcon sx={{ color: "#00B6CE", fontSize: 28 }} />
                  <h5 className="modal-title main-title">Bulk Message</h5>
                </div>
                <HighlightOffIcon
                  onClick={handleBack}
                  sx={{
                    cursor: "pointer",
                    color: "#777",
                    fontSize: 28,
                    transition: "0.3s",
                    "&:hover": {
                      color: "#00B6CE",
                      transform: "scale(1.1)",
                    },
                  }}
                />
              </div>
              <form onSubmit={(e) => handleAddUser(e)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  <div className="row mb-3 mt-3">
                    <div className="col-md-6" style={{ width: "276px" }}>
                      <label htmlFor="senderId" className="text-[#1A1A1A]">
                        Sender ID<span style={{ color: "red" }}>*</span>
                      </label>
                      <div
                        className="form-group position-relative"
                        ref={profileRef}
                      >
                        {/* <select
                          className="form-control"
                          id="senderId"
                          value={senderIdValue || ""}
                          // disabled={isViewMode || isDeleteMode || isEditMode}
                          placeholder="Select"
                          onChange={handleSenderIdChange}
                          onClick={handlefetchSenderId}
                        >
                          <option value="">
                            {isLoading ? "Loading..." : "Select"}
                          </option>
                          {!isLoading &&
                          Array.isArray(formData.senderId) &&
                          formData.senderId.length > 0
                            ? formData.senderId?.map((user) => (
                                <option>{user?.senderIdL}</option>
                              ))
                            : !isLoading && (
                                <option value="" disabled>
                                  No data found
                                </option>
                              )}
                        </select> */}
                        <CustomDropdown
                          options={formData.senderId}
                          valueKey="senderIdL"
                          labelKey="senderIdL"
                          value={senderIdValue}
                          placeholder="Select Sender ID"
                          onOpen={fetchSenderIdList}
                          onChange={(item) => {
                            // handleSenderIdChange();
                            setSenderIdValue(item.senderIdL);
                            setIsValidated(false);
                            setErrors({});
                          }}
                        />

                        {/* <span className="position-absolute select-icon">
                          {profileOpen ? <ChevronUp /> : <ChevronDownIcon />}
                        </span> */}
                      </div>
                      {errors.senderId ? (
                        <span className="error">{errors.senderId}</span>
                      ) : null}
                    </div>

                    <div className="col-md-6" style={{ width: "276px" }}>
                      <label htmlFor="entityId" className="text-[#1A1A1A]">
                        Entity ID<span style={{ color: "red" }}>*</span>
                      </label>
                      {/* <div
                        className="form-group position-relative"
                        ref={profileRef}
                      >
                        <select
                          className="form-control"
                          id="entityId"
                          // value={formData?.entityId || ""}
                          value={entityIdValue || ""}
                          // disabled={isViewMode || isDeleteMode || isEditMode}
                          placeholder="Select"
                          onChange={handleEntityIdChange}
                          onClick={entityList}
                        >
                          <option value="" disabled selected>
                            Select
                          </option>
                          {!loading &&
                          Array.isArray(formData.entityId) &&
                          formData.entityId.length > 0
                            ? formData.entityId?.map((user) => (
                                <option>{user?.entityId}</option>
                              ))
                            : !loading && (
                                <option value="" disabled>
                                  No data found
                                </option>
                              )}
                        </select>
                        <span className="position-absolute select-icon">
                          {profileOpen ? <ChevronUp /> : <ChevronDownIcon />}
                        </span>
                      </div> */}
                      <CustomDropdown
                        options={formData.entityId}
                        valueKey="entityId"
                        labelKey="entityId"
                        value={entityIdValue}
                        placeholder="Select Entity ID"
                        onOpen={entityList}
                        onChange={(item) => {
                          setEntityIdValue(item.entityId);
                          setIsValidated(false);
                          setErrors({});
                        }}
                      />
                      {errors.entityId ? (
                        <span className="error">{errors.entityId}</span>
                      ) : null}
                    </div>

                    <div
                      className="col-md-6"
                      style={{ width: "98%", marginTop: "10px", position: "relative" }}
                    >
                      <label htmlFor="templateId" className="text-[#1A1A1A]">
                        Template ID<span style={{ color: "red" }}>*</span>
                      </label>
                      <LocalTemplateDropdown
                        options={formData.templateId}
                        valueKey="templateId"
                        labelKey="templateId"
                        value={templateIdValue}
                        placeholder="Select Template ID"
                        onOpen={entityList}
                        onChange={(item) => {
                          setTemplateIdValue(item.templateId);
                          setIsValidated(false);
                          setErrors({});
                        }}
                        onHoverItem={setHoveredItem}
                      />
                      {hoveredItem && (
                        <div
                          style={{
                            position: "absolute",
                            left: "102%",
                            top: "30px",
                            width: "280px",
                            zIndex: 100,
                            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                            borderRadius: "12px",
                            backgroundColor: "#FFF",
                            padding: "8px",
                            border: "1px solid #E2E8F0",
                          }}
                        >
                          <TemplatePreview template={
                            templatesData?.find(t => String(t.template_id) === String(hoveredItem.templateId))
                          } />
                        </div>
                      )}
                      {errors.templateId ? (
                        <span className="error">{errors.templateId}</span>
                      ) : null}
                    </div>

                    {templateIdValue && (
                      <div className="col-md-6" style={{ width: "98%", marginTop: "16px" }}>
                        <TemplatePreview template={selectedTemplate} />
                      </div>
                    )}

                    {/* <div
                      className="col-md-6"
                      style={{ width: "98%", marginTop: "24px" }}
                    >
                      <div className="form-group">
                        <label htmlFor="smsText">
                          SMS Text<span style={{ color: "red" }}>*</span>
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          style={{
                            backgroundColor: "#F6F6F6",
                            borderColor: "snow",
                          }}
                          id="smsText"
                          rows="4"
                          value={formData?.smsText || ""}
                          // disabled={isViewMode || isDeleteMode  || isEditMode}
                          placeholder="Enter Message"
                          onChange={handleInputChange}
                        />
                        {errors.smsText ? (
                          <span className="error">{errors.smsText}</span>
                        ) : null}
                      </div>
                    </div> */}

                    <div
                      className="col-md-6"
                      style={{ width: "98%", marginTop: "24px" }}
                    >
                      <div
                        style={{
                          borderRadius: "10px",
                          border: "1px dashed #00B6CE",
                          padding: "16px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "#F6F6F6",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          opacity: isDisabled ? 0.6 : 1,
                        }}
                        onClick={!isDisabled ? triggerFileInput : undefined}
                      >
                        <div>
                          <p
                            style={{
                              margin: 0,
                              color: "#454545",
                              fontSize: "16px",
                            }}
                          >
                            Upload from your computer
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "12px",
                              color: "#6D6D6D",
                            }}
                          >
                            .XLSX files <br />
                            <span>{csvFile?.name}</span>
                          </p>
                        </div>
                        <img
                          src={ICONS.UploadCsvIcon}
                          alt="uploadCsv"
                          style={{ width: "31px" }}
                        />
                        <input
                          type="file"
                          accept=".xlsx"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          className="hidden"
                          style={{ display: "none" }}
                        />
                      </div>
                      {errors.csv ? (
                        <span className="error">{errors.csv}</span>
                      ) : null}
                    </div>

                    <div
                      className="col-md-6"
                      style={{
                        width: "98%",
                        marginTop: "24px",
                        display: "flex",
                        alignItems: "center",
                        gap: "13px",
                        cursor: "pointer",
                      }}
                      onClick={handelDownloadExcelFormat}
                    >
                      <img
                        src={ICONS.DownloadCsvIcon}
                        alt="downloadCsv"
                        style={{ width: "31px" }}
                      />
                      <p
                        style={{
                          margin: 0,
                          color: "#1A1A1A",
                          fontSize: "14px",
                          textDecoration: "none",
                          transition: "color 0.3s, text-decoration 0.3s",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.color = "#00B6CE";
                          e.target.style.textDecoration = "underline";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.color = "#1A1A1A";
                          e.target.style.textDecoration = "none";
                        }}
                      >
                        Download Sample Template
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingTop: "0px",
                    gap: "16px",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back z-10"
                    onClick={handleBack}
                    style={{ width: "150px", height: "52px" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-back"
                    style={{
                      width: "150px",
                      height: "52px",
                    }}
                    disabled={isDisabled}
                    onClick={validateBulkUpload}
                  >
                    Validate
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit"
                    style={{
                      width: "150px",
                      height: "52px",
                      cursor:
                        isDisabled || !isValidated ? "not-allowed" : "pointer",
                    }}
                    disabled={isDisabled || !isValidated}
                  >
                    Upload
                  </button>
                </div>
              </form>
            </div>
          </div>
          {showSuccessModal && (
            <SuccessModal
              show={showSuccessModal}
              handleClose={handleCloseModal}
            />
          )}
        </div>
      )}
    </>
  );
};

export default BulkMessageModal;
